<template lang="pug">
  v-row
    v-col(cols=12 align="center").py-0
      v-row(justify="center" align="center")
        v-col(cols="auto").py-0
          v-img(:src="medalSrc" style="width:min(8vw, 100px);").medalImg
        v-col(cols="auto").py-0
          b(
            style="font-size:min(5vw, 30px);"
          ) {{ $t('date') }} {{ date | date }}
        v-col(cols="auto").py-0
          v-img(:src="medalSrc" style="width:min(8vw, 100px);").medalImg
    
    v-col(cols=12 align="center")
      v-row(align="center" justify="center")
        v-col(cols="auto")
          b(
            style="font-size:min(4vw, 25px);"
          ) {{ $t('power-ball.search-previous') }}
        v-col(cols="auto" style="max-width:200px;")
          slot(name="selection")
    v-col(cols=12 v-if="winNumberArray.length !== 0")
      v-row(align="center" justify="center")
        h3.mr-2.grey--text {{ $t('power-ball.winnumber') }}
        v-col(cols="auto")
          winnumber(
            :win-number-array="winNumberArray"
          ).mr-2
        h3.mr-2.grey--text.mr-2 Power play
        h3 x {{ powerPlay }}
    v-col(cols=12 v-else align="center")
      h2 {{ $t('power-ball.game-not-over') }}

</template>
<script>
import Winnumber from '../components/Winnumber'
export default {
  components: {
    Winnumber
  },
  props: {
    winNumberArray: {
      type: Array,
      default: () => []
    },
    date: {
      type: String,
      default: null
    },
    powerPlay: {
      type: [String, Number],
      default: null 
    }
  },
  computed: {
    medalSrc: () => require('@/assets/powerball/icon-medal.svg'),
  }
}
</script>
<style scoped>
@media only screen and (max-width: 600px) {
  .medalImg {
    max-width: 50px !important;
  }
}
</style>